module.exports = __webpack_public_path__ + "img/share.1bb5dee6.png";